import { caseTiming } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk to add a teleradiology customer
export const getCaseTiming = createAsyncThunk(
  'getCaseTiming',
  async (_, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
      const response = await fetch(`${caseTiming}?hospitalId=${hospitalId}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch case timing');
      }

      return await response.json(); // Return the response data if successful
    } catch (error: any) {
      return rejectWithValue(error.message); // Handle any errors that occur
    }
  }
);

export default getCaseTiming;
